export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fc221b5aef9b547e179b67cbc7586a41.jpg"
          alt="HVAC Professional Service"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center">
        <div className="inline-block bg-white/95 backdrop-blur-sm px-5 py-2 rounded-full mb-8">
          <div className="flex items-center space-x-2">
            <i className="ri-fire-fill text-orange-600 text-base"></i>
            <span className="text-sm font-medium text-gray-900">Baltimore&apos;s Trusted HVAC Experts</span>
          </div>
        </div>

        <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight">
          TRIO HVACR<br />
          SERVICES
        </h1>
        <p className="text-3xl md:text-4xl font-light text-white/90 mb-12">
          Comfort You Can Trust
        </p>

        <p className="text-lg text-white/90 max-w-2xl mx-auto mb-12 leading-relaxed">
          Your trusted HVAC expert in Baltimore, MD, specializing in AC repair, boiler repair, HVAC service, and installation. We provide reliable solutions for all your heating and cooling needs.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={scrollToContact}
            className="bg-black text-white px-10 py-4 rounded-full text-base font-medium hover:bg-gray-900 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Schedule Service
          </button>
          <a
            href="tel:4433248816"
            className="text-white text-base font-medium underline hover:text-orange-300 transition-colors whitespace-nowrap cursor-pointer"
          >
            Call (443) 324-8816
          </a>
        </div>

        <div className="mt-16 flex items-center justify-center space-x-2">
          <div className="flex -space-x-2">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="w-10 h-10 rounded-full bg-orange-600 border-2 border-white flex items-center justify-center text-white text-xs font-bold">
                {String.fromCharCode(64 + i)}
              </div>
            ))}
          </div>
          <div className="text-white text-sm ml-3">
            <strong>500+</strong> Happy Customers
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
